<template>
    <app-moduleimage
        :data="getId"
        :tag="'div'"
        :custom-class="'module-background' + (this.customClass ? ' ' + this.customClass : '')"
    >
    </app-moduleimage>
</template>

<script>
import { mapGetters } from 'vuex';
import ModuleImage from '@/components/assorted/ModuleImage';

export default {
    data() {
        return {};
    },
    components: {
        'app-moduleimage': ModuleImage
    },
    methods: {},
    computed: {
        ...mapGetters(['getModuleBackground', 'getMenuBackground']),
        getId() {
            if (this.moduleId) {
                return this.getModuleBackground(this.moduleId);
            }
            if (this.menuId) {
                return this.getMenuBackground(this.menuId);
            }
            return null;
        }
    },
    created() {},
    mounted() {},
    props: {
        moduleId: null,
        menuId: null,
        customClass: null
    }
};
</script>
